import { useCallback } from 'react'

import useAppQueryState from '@hooks/useAppQueryState'
import { useBasin } from '@hooks/useBasin'

import { getAppConfig } from '@utils/getAppConfig'
import { getMarketingTrackingData } from '@utils/getMarketingTrackingData'

import { getAlternativeProductApplicationUrl } from '../utils/getAlternativeProductApplicationUrl'

interface UseGetAlternativeProductApplicationUrlOptions {
    clickId: string
    productCode: string
}

type useGetAlternativeProductApplicationUrlReturn = (
    options: UseGetAlternativeProductApplicationUrlOptions
) => string

const useGetAlternativeProductApplicationUrl =
    (): useGetAlternativeProductApplicationUrlReturn => {
        const appConfig = getAppConfig()
        const { appQueryState } = useAppQueryState()
        const trackingData = getMarketingTrackingData(appQueryState)

        const { ids } = useBasin()

        const memoizedGetAlternativeProductApplicationUrl = useCallback(
            ({
                productCode,
                clickId,
            }: UseGetAlternativeProductApplicationUrlOptions) => {
                return getAlternativeProductApplicationUrl({
                    clickSource: appConfig.CLICK_SOURCE_WHITELABEL,
                    productCode: productCode,
                    clickId,
                    visitGuid: ids?.sessionId!,
                    customerId: appQueryState.customerId!,
                    scoreId: appQueryState.scoreId!,
                    isKnownCustomer: appQueryState.isKnownCustomer!,

                    ...trackingData,
                })
            },
            [
                appQueryState.customerId,
                appQueryState.scoreId,
                appQueryState.isKnownCustomer,
                trackingData,
                ids?.sessionId,
            ]
        )

        return memoizedGetAlternativeProductApplicationUrl
    }

export default useGetAlternativeProductApplicationUrl
